module.exports = __webpack_public_path__ + "fonts/roboto-all-500.851a2b5a.woff";